import React from "react";
import './../styles/ShortProjectInfo.css';
import ProgrammingLanguagesBox from "./ProgrammingLanguagesBox";
const ShortProjectInfo = function (props) {
    return React.createElement("div", { className: "shortProjectInfoWrapper", onClick: projectBriefClicked() },
        React.createElement("img", { className: "projectImage", src: props.image, alt: props.title }),
        React.createElement("a", { className: "star" }, props.hasStar ? "⭐" : " "),
        React.createElement("div", { className: "shortProjectInfo" },
            React.createElement("strong", { className: "projectTitle" }, props.title),
            React.createElement("br", null),
            React.createElement("a", { className: "projectDescription" }, props.description)),
        React.createElement(ProgrammingLanguagesBox, { programmingLanguages: props.programmingLanguages }));
};
export default ShortProjectInfo;
function projectBriefClicked() {
    return function (event) {
        let target = event.target;
        while (!target.className.startsWith('fullProject')) {
            target = target.parentNode;
        }
        target.classList.toggle("collapsed");
    };
}
